// extracted by mini-css-extract-plugin
export var link = "_q1-0";